const legacyStatusLabels = {
  pending: 'Pendente',
  in_transit: 'Em transferência bancária',
  paid: 'Pago pela Stripe',
  failed: 'Falhou',
  canceled: 'Cancelado',
} as const

const receiptStatusLabels = { ...legacyStatusLabels, paid: 'Saque enviado' } as const

export function payoutStatusLabels(receiptsExperience: boolean) {
  return receiptsExperience ? receiptStatusLabels : legacyStatusLabels
}
